<header class="adc-header adc-shadow" *ngIf="type == 'type1'">
  <div class="adc-header-body adc-gap-2">
    <div class="adc-header-left">
      <span class="material-symbols-outlined adc-mt0 adc-ml10 adc-mr-4 adc-cursor-pointer" *ngIf="!sidebarToggle" (click)="toggleAction()">menu</span>
      <!-- <svg class="adc-mt0 adc-ml10 adc-mr-4 adc-cursor-pointer" *ngIf="!showToggle" height="24" width="24" (click)="toggleAction()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" /></svg> -->
      <!-- <svg  class="adc-mt0 adc-ml10 adc-cursor-pointer" *ngIf="showToggle" fill="none" viewBox="0 0 24 24" height="20" width="20" xmlns="http://www.w3.org/2000/svg" (click)="toggleAction()">
        <path clip-rule="evenodd" d="m5.00073 17.5864c-.3905.3906-.39044 1.0237.00012 1.4142s1.02372.3905 1.41421-.0001l5.58524-5.5862 5.5857 5.5857c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-5.5858-5.5858 5.5854-5.58638c.3904-.39056.3904-1.02372-.0002-1.41421-.3905-.3905-1.0237-.39044-1.4142.00012l-5.5853 5.58627-5.58572-5.58579c-.39052-.39052-1.02369-.39052-1.41421 0-.39053.39053-.39053 1.02369 0 1.41422l5.58593 5.58587z" fill="rgb(0,0,0)" fill-rule="evenodd"/>
      </svg> -->
      <span class="material-symbols-outlined adc-mt0 adc-ml10 adc-cursor-pointer" *ngIf="sidebarToggle" (click)="toggleAction()">close</span>

      <!-- <div class="adc-brand"> -->
        <!-- <img src="{{data.logo}}" alt="logo" class="adc-w-25 adc-mb4 big"> -->
        <img src="{{data.logo}}" alt="logo" class="adc-mb8 small">
      <!-- </div> -->
      <div class="adc-d-flex adc-align-items-center adc-position-relative adc-srh" *ngIf="data.search"> 
        <input type="text" name="" id="" class="adc-w-75" placeholder="Search...">
        <!-- <img src="../../../assets/icons/search.png" class="adc-size-15 adc-position-absolute" style="right: 15px;"> -->
        <span class="material-symbols-outlined adc-size-15 adc-position-absolute" style="right: 15px; top: 0px; font-size: 25px">search</span>
      </div>
      <div class="adc-dropdown" *ngIf="data.dropdown" #dropdown1>
        {{data.dropdown}}
        <button class="adc-dropbtn" style="padding-top: 3px; padding-bottom: 3px;" (click)="dropdown($event)">Menu<span class="adc-align-self-center adc-mt5"><img src="../../../assets/down-arrow (1).png" alt="downarrow" [ngClass]="showDropdown ? 'adc-dropdownOpen' : ''"></span></button>
        <div class="adc-dropdown-option-menu" appendTo="body" *ngIf="showDropdown">
          <a class="adc-dropdown-options" *ngFor="let i of data.dropdownItems" (click)="dropdown($event)">{{i.itemLabel | translate}}</a>
        </div>
      </div>
      <div>
        <ng-content select="[left]"></ng-content>
      </div>
      <!-- <a>Dashboard</a>
      <a>Maintenance</a>
      <a>Organization
        <select name="" id="">
          <option value="">Option 1</option>
          <option value="">Option 2</option>
        </select>
      </a>
      <a>Task</a>
      <a>Meetings</a> -->
    </div>
    <div class="adc-header-right">
      <div class="adc-dropdown" #dropdown3 *ngIf="data.language" appClickOutside (clickOutside)="langDropdown = false">
        <button class="big adc-btn adc-btn-primary org-button" (click)="toggleLangDropdown()">
          <div class="adc-d-flex adc-align-items-center adc-gap-1">
            <span class="material-symbols-outlined lang-globe">globe</span>
            <span class="adc-slcorg">{{currentLanguage | uppercase}}</span>
          </div>
          <span class="material-symbols-outlined adc-fs-1 adc-mt3">keyboard_arrow_down</span>
          <!-- <span class="adc-slcorg">{{currentLanguage}}</span> -->
        </button>
        <div class="adc-dropdown-option-menu" appendTo="body" *ngIf="langDropdown">
          <a class="adc-dropdown-options" title="{{i.itemLabel}}" *ngFor="let i of data.langItems" (click)="toggleLangDropdown(); toggleLang(i)">{{i.itemLabel}}</a>
        </div>
      </div>
      <div *ngIf="data.fontZoom" class="adc-d-flex">
        <button class="adc-btn adc-btn-outline-primary fontButton" style="padding: 5px;" (click)="fontsizeChanges('Increase')" title="{{'Increase font size' | translate}}">
          <!-- <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--adc-primary-theme)"><path d="m40-200 210-560h100l210 560h-96l-51-143H187l-51 143H40Zm176-224h168l-82-232h-4l-82 232Zm504 104v-120H600v-80h120v-120h80v120h120v80H800v120h-80Z"/></svg> -->
          <span class="material-symbols-outlined">text_increase</span>
        </button>
        <button class="adc-btn adc-btn-outline-primary fontButton" (click)="fontsizeChanges('Reset')" title="{{'Reset font size' | translate}}">
          <!-- <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--adc-primary-theme)"><path d="M200-200v-80h560v80H200Zm76-160 164-440h80l164 440h-76l-38-112H392l-40 112h-76Zm138-176h132l-64-182h-4l-64 182Z"/></svg> -->
          <span class="material-symbols-outlined">text_format</span>
        </button>
        <button class="adc-btn adc-btn-outline-primary fontButton" (click)="fontsizeChanges('Decrease')" title="{{'Decrease font size' | translate}}">
          <!-- <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--adc-primary-theme)"><path d="m40-200 210-560h100l210 560h-96l-51-143H187l-51 143H40Zm176-224h168l-82-232h-4l-82 232Zm384-16v-80h320v80H600Z"/></svg> -->
          <span class="material-symbols-outlined">text_decrease</span>
        </button>
      </div>
      <div>
        <ng-content select="[right]"></ng-content>
      </div>
      <ng-container *ngFor="let i of data.rightItems; let rightIndex = index">
        <div class="adc-dropdown" #dropdown2  appClickOutside (clickOutside)="closeDropdown()" (click)="onDropdownClick($event)">
          <!-- <mat-icon (click)="toggleRightDropdown(rightIndex)">{{i.itemName}}</mat-icon> -->
          <!-- <img src="{{ i.itemIcon }}" alt="" class="adc-mt5 adc-cursor-pointer" (click)="toggleRightDropdown(rightIndex)" title="{{i.itemLabel}}"> -->
          <span class="adc-d-flex adc-cursor-pointer">
            <span class="material-symbols-outlined" (click)="toggleRightDropdown(rightIndex, $event)" title="{{i.itemLabel | translate}}">{{ i.itemIcon | translate }}</span>
            <!-- <span class="material-symbols-outlined">arrow_drop_down</span> -->
          </span>
          <div class="adc-dropdown-option-menu adc-rt0 adc-mt10" appendTo="body" *ngIf="showRightDropdown && activeRightDropdownIndex === rightIndex && i.children">
            <a class="adc-dropdown-options adc-d-flex adc-gap-1" (click)="actionRight(i.itemName, childItem.label)" *ngFor="let childItem of i.children" >
              <div class="theme" ngClass="{{ childItem.customClass }}" *ngIf="i.itemLabel === 'Theme'"></div>
              {{ childItem.label | translate }}
            </a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</header>

<header class="adc-header adc-shadow " *ngIf="type == 'type2'">
  <div class="adc-header-body">
    <div class="adc-header-left">
      <img src="{{data.logo}}" *ngIf="data.logoAlignment == 'left'" alt="" class="adc-w-100px">
      <div class="adc-navItem adc-pl20">
        <a class="adc-mr16" *ngFor="let i of data.leftItems">{{ i.itemLabel | translate}}</a>
      </div>

      <div class="adc-dropdown adc-navDropdown-1">
        <button class="adc-dropbtn" (click)="dropdown($event)">More<span class="adc-align-self-center adc-mt5"><img src="../../../assets/down-arrow (1).png" alt="downarrow"></span></button>
        <div class="adc-dropdown-option-menu" appendTo="body" *ngIf="showDropdown">
          <a class="adc-dropdown-options" *ngFor="let i of data.leftItems">{{ i.itemLabel | translate }}</a>
        </div>
      </div>

      <div class="adc-dropdown adc-navDropdown-2">
        <button class="adc-dropbtn" (click)="dropdown($event)">Menu<span class="adc-align-self-center adc-mt5"><img src="../../../assets/down-arrow (1).png" alt="downarrow"></span></button>
        <div class="adc-dropdown-option-menu" appendTo="body" *ngIf="showDropdown">
          <a class="adc-dropdown-options">
          
            <div class="adc-srh"> 
              <input type="text" name="" id=""  placeholder="Search..">
              <!-- <img src="../../../assets/icons/search.png" class="adc-search-icon" (click)="search(searchInput)"> -->
              <!-- <mat-icon>search</mat-icon> -->
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px"><title>magnify</title><path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" /></svg>
          </div>
          </a>
          <a class="adc-dropdown-options" *ngFor="let i of data.allItems">{{ i.itemLabel | translate }}</a>
        </div>
      </div>


      <!-- <a>Organization
        <select name="" id="">
          <option value="">Option 1</option>
          <option value="">Option 2</option>
        </select>
      </a>
      <a>Task</a>
      <a>Meetings</a> -->
    </div>

    <div class="adc-header-center">
      <img src="{{data.logo}}" *ngIf="data.logoAlignment == 'center'" alt="" class="adc-w-100px">

      <div class="adc-srh header-search" *ngIf="data.searchAlignment == 'center'"> 
        <input type="text" name="" id=""  placeholder="Search..">
        <!-- <img src="../../../assets/icons/search.png" class="adc-search-icon" (click)="search(searchInput)"> -->
        <!-- <mat-icon>search</mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px"><title>magnify</title><path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" /></svg>
    </div>
    </div>

    <div class="adc-header-right">
      <div class="adc-srh " *ngIf="data.searchAlignment == 'right'"> 
        <input type="text" name="" id=""  placeholder="Search..">
        <!-- <img src="../../../assets/icons/search.png" class="adc-search-icon" (click)="search(searchInput)"> -->
        <!-- <mat-icon>search</mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px"><title>magnify</title><path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" /></svg>
    </div>
      <img *ngFor="let i of data.rightItems" src="{{i.itemIcon}}" alt="" class="adc-size-20">
      <!-- <mat-icon *ngFor="let i of data.rightItems">{{i.itemName}}</mat-icon> -->
      <!-- <mat-icon>notifications_none</mat-icon>
      <mat-icon>person_outline</mat-icon> -->
    </div>
  </div>
</header>